import moment from 'moment'
import docendo from '../docendo'

export function parseSubjectEvents (payload) {
  if (Array.isArray(payload)) return payload
  if (typeof payload === 'string' && payload.length > 0) {
    try {
      const parsed = JSON.parse(payload)
      return Array.isArray(parsed) ? parsed : []
    } catch (e) {
      return []
    }
  }
  return []
}

export function firstEventOnOrAfter (events, fromDate) {
  if (!Array.isArray(events) || !fromDate) return null
  const from = moment(fromDate).startOf('day')
  return events
    .filter(event => event && event.start && moment(event.start).isSameOrAfter(from))
    .sort((a, b) => moment(a.start).valueOf() - moment(b.start).valueOf())[0] || null
}

export function loadEventsForSubject (subjectId, success, failure) {
  docendo.eventsBySubjects([subjectId], null, null, payload => {
    success(parseSubjectEvents(payload))
  }, failure)
}

function applyTeacherOnScheduledEventsFromDate (options, apiFn, success, failure) {
  const schoolId = options.schoolId
  const calendarId = options.calendarId
  const fromDate = options.fromDate
  const events = options.events || []
  const event = firstEventOnOrAfter(events, fromDate)
  if (!event || !event.event_id) {
    success({ applied: false, reason: 'no_events_from_date' })
    return
  }
  const eventSchoolId = event.school_id || schoolId
  apiFn(eventSchoolId, event.event_id, calendarId, options.enddate || null, () => {
    success({ applied: true, eventId: event.event_id })
  }, failure)
}

export function addTeacherToScheduledEventsFromDate (options, success, failure) {
  applyTeacherOnScheduledEventsFromDate(options, docendo.eventAddCalendar.bind(docendo), success, failure)
}

export function removeTeacherFromScheduledEventsFromDate (options, success, failure) {
  applyTeacherOnScheduledEventsFromDate(options, docendo.eventRemoveCalendar.bind(docendo), success, failure)
}



// WEBPACK FOOTER //
// ./src/utils/assignTeacherToScheduledEvents.js